import React, { useState, useMemo } from 'react';
import { Box, Stack } from '@mui/material';

function renderCell(value) {
    if (Array.isArray(value)) {
        if (value.length > 0 && typeof value[0] === 'object' && value[0] !== null && !Array.isArray(value[0])) {
            const keys = Object.keys(value[0]);
            return (
                <table
                    className="json-to-table"
                    border="1"
                    cellPadding="3"
                    style={{ borderCollapse: 'collapse', margin: '5px 0' }}
                >
                    <thead>
                        <tr>{keys.map(k => <th key={k}>{k}</th>)}</tr>
                    </thead>
                    <tbody>
                        {value.map((item, idx) => (
                            <tr key={idx}>
                                {keys.map(k => (
                                    <td key={k}>{renderCell(item[k])}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        } else {
            return (
                <table
                    className="json-to-table"
                    border="1"
                    cellPadding="3"
                    style={{ borderCollapse: 'collapse', margin: '5px 0' }}
                >
                    <tbody>
                        {value.map((item, idx) => (
                            <tr key={idx}>
                                <td>{renderCell(item)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }
    } else if (typeof value === 'object' && value !== null) {
        const keys = Object.keys(value);
        return (
            <table
                className="json-to-table"
                border="1"
                cellPadding="3"
                style={{ borderCollapse: 'collapse', margin: '5px 0' }}
            >
                <tbody>
                    <tr>
                        {keys.map(k => (
                            <td key={k}><strong>{k}</strong></td>
                        ))}
                    </tr>
                    <tr>
                        {keys.map(k => (
                            <td key={k}>{renderCell(value[k])}</td>
                        ))}
                    </tr>
                </tbody>
            </table>
        );
    } else if (typeof value === 'string') {
        const html = value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\n/g, "<br>");
        return <span dangerouslySetInnerHTML={{ __html: html }} />;
    } else {
        return value !== null ? value?.toString() : '';
    }
}

function HistoryJsonToTable({ data }) {
    const isFieldFormat = data && typeof data === "object" && "data" in data;

    const fieldMap = isFieldFormat && data.field ? data.field : {};
    const rows = isFieldFormat ? data.data : (Array.isArray(data) ? data : [data]);

    const dataKeys = Array.from(new Set(rows.flatMap(row => Object.keys(row))));

    const columns = dataKeys;

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const totalPages = Math.ceil(rows.length / pageSize);

    const currentPageRows = useMemo(() => {
        const start = (page - 1) * pageSize;
        const end = start + pageSize;
        return rows.slice(start, end);
    }, [rows, page, pageSize]);

    const handlePrev = () => setPage(p => Math.max(p - 1, 1));
    const handleNext = () => setPage(p => Math.min(p + 1, totalPages));

    return (
        <div>
            <div
                style={{
                    minHeight: "calc(100vh - 300px)",
                    maxHeight: "calc(100vh - 300px)",
                    overflow: "auto",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                }}
            >
                <table
                    className="json-to-table"
                    border="1"
                    cellPadding="5"
                    style={{ borderCollapse: 'collapse', width: '100%' }}
                >
                    <thead>
                        <tr>
                            {columns.map(col => (
                                <th key={col}>
                                    {fieldMap[col] || col}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {currentPageRows.map((row, idx) => (
                            <tr key={idx} className={idx % 2 === 0 ? 'even' : 'odd'}>
                                {columns.map(col => (
                                    <td key={col}>{renderCell(row[col])}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Box sx={{ paddingX: "10px" }}>
                <Stack direction="row" justifyContent="space-between" spacing={1}>
                    <div
                        style={{
                            marginTop: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                        }}
                    >
                        <button onClick={handlePrev} disabled={page === 1}>
                            {`<`}
                        </button>
                        <span>{page} / {totalPages || 1}</span>
                        <button onClick={handleNext} disabled={page === totalPages || totalPages === 0}>
                            {`>`}
                        </button>
                    </div>
                    <div
                        style={{
                            marginTop: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '10px',
                        }}
                    >
                        <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            {[20, 50, 80, 100].map(size => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>
                </Stack>
            </Box>
        </div>
    );
}

export default HistoryJsonToTable;
